import React, { useMemo } from 'react';
import { ISelectOption, ISelectProps, Select } from '../../../../ui-toolkit';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../../API/documentCategories/DocumentCategoriesApi';

const getCategoryOptions = ({
  sortedCategories,
  categoryFilter = () => true,
}: {
  sortedCategories: IDocumentCategory[];
  categoryFilter?: (category: IDocumentCategory) => boolean;
}): ISelectOption<IDocumentCategory>[] => {
  return sortedCategories.filter(categoryFilter).map((category) => ({ value: category, label: category.label }));
};

interface DocumentCategorySelectorProps extends ISelectProps {
  categoryFilter?: (category: IDocumentCategory) => boolean;
  selectedCategory?: IDocumentCategory | null;
}

export const DocumentCategorySelector: React.FC<DocumentCategorySelectorProps> = ({
  categoryFilter,
  selectedCategory,
  ...rest
}) => {
  const { data: { sortedActiveCategories } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();

  const options = useMemo(
    () => getCategoryOptions({ sortedCategories: sortedActiveCategories, categoryFilter }),
    [sortedActiveCategories, categoryFilter]
  );

  const selectValue = selectedCategory
    ? (options.find((option) => option.value.name === selectedCategory.name) ?? null)
    : null;

  return <Select {...rest} options={options} value={selectValue} />;
};
